var _path, _rect, _rect2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6079 48.3454C25.76 44.6179 29.4895 42.1602 33.1268 39.8589C39.1754 36.0319 43.1917 29.2829 43.1917 21.5959C43.1917 9.66879 33.5229 0 21.5959 0C9.66879 0 0 9.66879 0 21.5959C0 29.283 4.01641 36.0321 10.0652 39.8591C13.7026 42.1604 17.4324 44.6182 19.5845 48.3458L20.7301 50.33C21.115 50.9967 22.0772 50.9967 22.4621 50.33L23.6079 48.3454Z",
    fill: "url(#paint0_linear_712_5790)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.79956,
    y: 6.79956,
    width: 29.5586,
    height: 29.5586,
    rx: 14.7793,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.79956,
    y: 6.79956,
    width: 29.5586,
    height: 29.5586,
    rx: 14.7793,
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 20.8889C31 25.7981 25.375 32 22 32C18.625 32 13 25.7981 13 20.8889C13 15.9797 17.0294 12 22 12C26.9706 12 31 15.9797 31 20.8889ZM27 21C27 22.6967 26.1549 24.196 24.8626 25.1C24.0517 25.6672 23.0647 26 22 26C20.9353 26 19.9483 25.6672 19.1374 25.1C17.8451 24.196 17 22.6967 17 21C17 18.2386 19.2386 16 22 16C24.7614 16 27 18.2386 27 21ZM23.5 19C23.5 19.8284 22.8284 20.5 22 20.5C21.1716 20.5 20.5 19.8284 20.5 19C20.5 18.1716 21.1716 17.5 22 17.5C22.8284 17.5 23.5 18.1716 23.5 19ZM24.5 23.5C24.1177 22.2829 23.3434 21.5 22.0001 21.5C20.6568 21.5 19.8823 22.2829 19.5 23.5C20.3109 24.0673 20.9354 24.5 22.0001 24.5C23.0648 24.5 23.6891 24.0673 24.5 23.5Z",
    fill: "url(#paint1_linear_712_5790)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_712_5790",
    x1: 21.5959,
    y1: 0,
    x2: 21.5959,
    y2: 50.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E20FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0001A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_712_5790",
    x1: 22,
    y1: 12,
    x2: 22,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E20FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0001A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.8fe434093f59ef0e2d04567cf30d6a03.svg";
export { ForwardRef as ReactComponent };